/* eslint-disable camelcase */
import { useQuery, UseQueryOptions } from 'react-query';
import { AxiosResponse, AxiosError } from 'axios';

import httpClient from 'utils/httpClient';

export const GET_SESSIONS_MISSING_EVALUATION =
  '/v2/sessions-missing-evaluation';

export type WarningSession = {
  id: number | string;
  unit_id?: number;
  course_id: number;
  type: number;
  warningType: string;
  warningText: string;
  penaltyInfo?: string;
  testRequired?: boolean;
  test?: any;
  testTitle?: string;
  testDuration?: number;
  hasEvaluation?: boolean;
  evaluation?: boolean;
  occurredAt: string;
  title: string;
  isUnit?: boolean;
};

export type CourseWithWarnings = {
  id: number;
  title: string;
  status: number;
  type: number;
  student: any;
  teacher: any;
  carer: any;
  warningSessions: WarningSession[];
  warningCount: number;
};

export type GetSessionsMissingEvaluationResponse = {
  courses: CourseWithWarnings[];
  pagination: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
    from: number;
    to: number;
  };
};

export type GetSessionsMissingEvaluationParams = {
  pageSize?: number;
  page?: number;
};

export const getSessionsMissingEvaluation = (
  params?: GetSessionsMissingEvaluationParams,
) =>
  httpClient.get<GetSessionsMissingEvaluationResponse>(
    GET_SESSIONS_MISSING_EVALUATION,
    {
      params: {
        'page-size': params?.pageSize ?? 20,
        page: params?.page ?? 1,
      },
    },
  );

export const useGetSessionsMissingEvaluation = (
  params?: GetSessionsMissingEvaluationParams,
  opts?: UseQueryOptions<
    AxiosResponse<GetSessionsMissingEvaluationResponse>,
    AxiosError<any>
  >,
) =>
  useQuery<
    AxiosResponse<GetSessionsMissingEvaluationResponse>,
    AxiosError<any>
  >(
    [GET_SESSIONS_MISSING_EVALUATION, params],
    () => getSessionsMissingEvaluation(params),
    {
      ...opts,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  );
